const counties = ["baringo","bomet","bungoma","busia","elgeyo marakwet","embu","garissa","homa bay","isiolo","kajiado","kakamega","kericho","kiambu","kilifi","kirinyaga","kisii","kisumu","kitui","kwale","laikipia","lamu","machakos","makueni","mandera","meru","migori","marsabit","mombasa","muranga","nairobi","nakuru","nandi","narok","nyamira","nyandarua","nyeri","samburu","siaya","taita taveta","tana river","tharaka nithi","trans nzoia","turkana","uasin gishu","vihiga","wajir","pokot"]

let parsedCounties = [];

for(let i=0; i<counties.length; i++){
    parsedCounties.push({value: counties[i].charAt(0).toUpperCase() + counties[i].slice(1), label: counties[i].charAt(0).toUpperCase() + counties[i].slice(1)})
}

export default parsedCounties;